import { ActionTypesActivityLog } from './constants';
import { ActivityLogInitialStateType, ActivityLogAPIType } from './types';

const initialState: ActivityLogInitialStateType = {
  activityLogData: [] as ActivityLogAPIType[],
  activityLogDaysView: '7',
  isActivityLogDataLoading: false,
};

function activityLogReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesActivityLog.SET_ACTIVITY_LOG_DATA:
      return {
        ...state,
        activityLogData: action.gridData,
      };
    case ActionTypesActivityLog.SET_ACTIVITY_LOG_DAYS_VIEW:
      return {
        ...state,
        activityLogDaysView: action.days,
      };
    case ActionTypesActivityLog.TOGGLE_IS_ACTIVITY_LOG_DATA_LOADING:
      return {
        ...state,
        isActivityLogDataLoading: action.isLoading,
      };
    default:
      return state;
  }
}

export default activityLogReducer;
